import { useQuery as s } from "@tanstack/react-query";
import t from "./lessons.api.js";
import { teachurKeys as n } from "../../constants/teachurKeys.js";
const y = (e, r) => s({
  queryKey: n.lessons.detail(e),
  queryFn: async () => (await t.getOne(e)).data,
  enabled: !!e && !isNaN(e),
  ...r
}), c = (e, r) => s({
  queryKey: n.lessons.objectives(e),
  queryFn: async () => (await t.getObjectives(e)).data,
  enabled: !!e,
  staleTime: 300 * 1e3,
  ...r
});
export {
  c as useGetLessonObjectivesQuery,
  y as useGetLessonQuery
};
